import { render } from "./AiAssistantButton.vue?vue&type=template&id=d2edbdfc&scoped=true"
import script from "./AiAssistantButton.vue?vue&type=script&lang=js"
export * from "./AiAssistantButton.vue?vue&type=script&lang=js"

import "./AiAssistantButton.vue?vue&type=style&index=0&id=d2edbdfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2edbdfc"]])

export default __exports__